import { useMemo, useRef, useState, useLayoutEffect } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { editorToSections } from "../utils/pageEditorTransforms";
import PageSectionRenderer from "./PageSectionRenderer";

const SCALE = 0.55;

const PreviewDialog = ({ visible, onHide, title, navLabel, sections, onConfirm }) => {
    const contentRef = useRef(null);
    const [wrapperHeight, setWrapperHeight] = useState(null);
    const renderedSections = useMemo(() => editorToSections(sections), [sections]);

    useLayoutEffect(() => {
        if (!visible) return;
        const measure = () => {
            const el = contentRef.current;
            if (!el) return;
            const natural = el.scrollHeight || 0;
            if (natural) setWrapperHeight(Math.ceil(natural * SCALE));
        };
        measure();
        const el = contentRef.current;
        if (!el) return;
        const imgs = el.querySelectorAll("img");
        imgs.forEach((img) => {
            if (!img.complete) img.addEventListener("load", measure, { once: true });
        });
        const ro = new ResizeObserver(measure);
        ro.observe(el);
        return () => ro.disconnect();
    }, [visible, sections]);

    return (
        <Dialog
            header={`Vista previa: ${title || navLabel || "Página"}`}
            visible={visible}
            onHide={onHide}
            draggable={false}
            resizable={false}
            className="admin-preview-page-dialog"
            dismissableMask
            footer={
                <div style={{ display: "flex", gap: "0.5rem", justifyContent: "flex-end" }}>
                    <Button label="Cancelar" severity="secondary" outlined onClick={onHide} />
                    <Button label="Confirmar guardado" icon="pi pi-check" severity="success" onClick={() => { onHide(); onConfirm(); }} />
                </div>
            }
        >
            <div className="admin-preview-page-container">
                <div className="admin-preview-page-centered" style={wrapperHeight ? { height: wrapperHeight } : undefined}>
                    <div ref={contentRef} className="admin-preview-page-scaled">
                        {renderedSections.map((section, index) => (
                            <PageSectionRenderer key={`preview-${section?.type || "section"}-${index}`} section={section} index={index} />
                        ))}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default PreviewDialog;